import { computed } from 'vue';
import { useRoute } from 'vue-router';
import useLocale from './useLocale';
import useMyQuoteBasic from './ct/useMyQuote';

function useMyQuote() {
  const { locale } = useLocale();
  const route = useRoute();
  const id = computed(() => route.params.id);
  const queryParam = computed(()=> route.query.state);

  const { loading, error, quote, getMyQuote, acceptQuoteRequest, sendStagedQuote, rejectQuoteRequest, getQuotationCart, quoteRefetch, addSellerComment } = useMyQuoteBasic({
    id,
    locale,
    queryParam
  });

  return { loading, error, quote, getMyQuote, acceptQuoteRequest, sendStagedQuote, rejectQuoteRequest, getQuotationCart, quoteRefetch, addSellerComment };
}
export default useMyQuote;
